<template>
    <div>
        <template v-if="singleTobObj.devcBaseInfoFalg">
            <div class="content-caption dashed">
                <span>设备基础信息</span>
            </div>
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产描述全称</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDevice.title || '无' ">{{shopDevice.title || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产名称</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDevice.name || '无' ">{{shopDevice.name || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>品牌</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDevice.brandName || '无' ">{{shopDevice.brandName || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>型号</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDevice.model || '无' ">{{shopDevice.model || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>规格</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDevice.fixedSpec || '无' ">{{shopDevice.fixedSpec || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>商品标识码</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDevice.vendorUkno || '无' ">{{shopDevice.vendorUkno || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>特种设备</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.specialFlag ? "是" : "否"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>创建时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.createTime || '无'}}</span>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="singleTobObj.repairInfoFalg">
            <div class="content-caption dashed">
                <span>设备维保信息</span>
            </div>
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>保内</label>
                    </div>
                    <div class="form-value">
                        <span class="font-red" v-if="shopDevice.wrntDueTime != null && new Date(shopDevice.currentTime).getTime() > new Date(shopDevice.wrntDueTime).getTime()">否</span>
                        <span class="font-green" v-if="shopDevice.wrntDueTime == null || new Date(shopDevice.currentTime).getTime() <= new Date(shopDevice.wrntDueTime).getTime()">是</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>质保期(月)</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.wrntPeriod || '0'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>质保开始时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.wrntStartTime || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>质保到期时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.wrntDueTime || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>需维修</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.repairFlag ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>需巡查</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.patrolFlag ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>需保养</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.maintFlag ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>需要安装</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.setupFlag ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>需要控温</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDevice.temperFlag ? '需要' : '不需要' ">{{shopDevice.temperFlag ? '需要' : '不需要'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>故障次数</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.faultTimes || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>维修次数</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.repairTimes || '0'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>最近维保时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.lastRepairTime || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>延保单</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.existWrntExtVoucher ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>维保分组</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.devcGroupFullName || ''}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>定义描述全称</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.devcDefTitle || ''}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>故障中数量</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.failedQuantity}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>维修中数量</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.repairingQuantity}}</span>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="singleTobObj.manageInfoFalg">
            <div class="content-caption dashed">
                <span>设备保管信息</span>
            </div>
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>业务单元</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.retailerBizUnitName || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>所在部门</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.retailerComFullName || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>责任部门</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.respblDepartName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>责任人</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.respblStaffName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>所在经度</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.lng}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>所在纬度</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.lat}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>位置编码</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.locCode}}</span>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="singleTobObj.useInfoFalg">
            <div class="content-caption dashed">
                <span>设备使用信息</span>
            </div>
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>启用日期</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.initStartDate || ''}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>机构启用日期</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.startDate || ''}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产状态</label>
                    </div>
                    <div class="form-value">
                        <span v-if="shopDevice.useState == 0">未启用</span>
                        <span v-if="shopDevice.useState == 1">已启用</span>
                        <span v-if="shopDevice.useState == 2">已停用</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>运行状态</label>
                    </div>
                    <div class="form-value">
                        <span class="font-green" v-if="shopDevice.state == 0">正常</span>
                        <span class="font-red" v-if="shopDevice.state == 1">有故障</span>
                        <span class="font-black" v-if="shopDevice.state == 2">已报修</span>
                        <span class="font-black" v-if="shopDevice.state == 3">维修中</span>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label>在用数量</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.inUseQuantity || 0}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>在库数量</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.inStkQuantity}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>是否锁定</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.locked ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>锁定业务类型</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.locked ? devcVoucherTypeList[shopDevice.lockBizType] : ''}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>锁定单号</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.locked ? shopDevice.lockBizInnerNo : ''}}</span>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label>最近操作时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.actTime || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>最近扫码时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.qrScanTime || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>领用部门</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.applyUseDepartName || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>领用人</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.applyUseStaffName || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>所属套装</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.suitName || "无"}}</span>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="singleTobObj.devcStatisInfoFalg">
            <div class="content-caption dashed">
                <span>设备统计信息</span>
            </div>
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>单位</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.theUnit || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>业务标签</label>
                    </div>
                    <div class="form-value">
                        <template v-for="tagName in shopDevice.tagNames">
                            <span class="swb-tags swb-tags-success mr5">{{tagName}}</span>
                        </template>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>机构标签</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.retailerShopTagName || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>在库数量</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.inStkQuantity}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>机构使用时长(天)</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.startTimeDay || '0'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>机构停用时长(分)</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.outageTimeMi || '0'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>本次闲置时长(时)</label>
                    </div>
                    <div class="form-value">
                        <span>{{((shopDevice.curIdleTimeMi || 0) / 60).toFixed(1)}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>以前闲置时长(时)</label>
                    </div>
                    <div class="form-value">
                        <span>{{(shopDevice.idleTimeMi / 60).toFixed(1)}}</span>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="singleTobObj.assetBaseInfoFalg">
            <div class="content-caption dashed">
                <span>资产基础信息</span>
            </div>
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产编号</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.innerCode || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产属性</label>
                    </div>
                    <div class="form-value">
                        <span v-if="assetNatureList[shopDevice.assetNature] != null">{{assetNatureList[shopDevice.assetNature].text || '无'}}</span>
                        <span v-else>无</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产分类</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.innerDevcCatName || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>外部系统编号</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDevice.innerNo || '无' ">{{shopDevice.innerNo || '无'}}</span>
                    </div>
                </div>
                <!--<div class="form-group center">-->
                <!--<div class="form-label">-->
                <!--<label>可拆分</label>-->
                <!--</div>-->
                <!--<div class="form-value">-->
                <!--<span>{{shopDevice.splitible ? '是' : '否'}}</span>-->
                <!--</div>-->
                <!--</div>-->
            </div>
        </template>

        <template v-if="singleTobObj.financeInfoFalg">
            <div class="content-caption dashed">
                <span>资产台账信息</span>
            </div>
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>折旧分摊规则编码</label>
                    </div>
                    <div class="form-value">
                        <span v-if="shopDevice.deprSpecId != null && shopDevice.deprSpecId != -1"><a class="table-cell-link" @click="showDeprSpec(shopDevice.deprSpecId)">{{shopDevice.deprSpecCode}}</a></span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>未税单价(元)</label>
                    </div>
                    <div class="form-value">
                        <span v-if="shopDevice.ntxPrice != null">{{shopDevice.ntxPrice.toFixed(2) || 0.00}}</span>
                        <span v-else>0.00</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>含税单价(元)</label>
                    </div>
                    <div class="form-value">
                        <span v-if="shopDevice.price != null">{{shopDevice.price.toFixed(2) || 0.00}}</span>
                        <span v-else>0.00</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>入账时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.fiscalInTime || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>入账方式</label>
                    </div>
                    <div class="form-value">
                        <span>{{acctEnterWayMap[shopDevice.acctEnterWay]}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>使用年限（月）</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.durableLife || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>折旧方式</label>
                    </div>
                    <div class="form-value">
                        <span>{{assetDeprMethodMap[shopDevice.deprMethodCode] || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="shopDevice.fiscalAcctFlag == 1">
                    <div class="form-label">
                        <label>折旧完毕</label>
                    </div>
                    <div class="form-value">
                        <span class="font-red" v-if="shopDevice.deprOver">是</span>
                        <span v-else>否</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>残值率(%)</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.rmnWorthRatio || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>原值(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.orgWorth == null ? '无' : shopDevice.orgWorth.toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>净值(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.netWorth == null ? '无' : shopDevice.netWorth.toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>累计折旧(元)</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.aggtDeprWorth == null ? '无' : shopDevice.aggtDeprWorth.toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>最后折旧月份</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.lastDeprMonth || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>税率(%)</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.taxRate == null ? '无' : shopDevice.taxRate.toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="shopDevice.deprMethodCode == 'SLD' || shopDevice.deprMethodCode == 'ASM'">
                    <div class="form-label">
                        <label>首次计提</label>
                    </div>
                    <div class="form-value">
                        <div class="form-value">
                            <span class="font-red" v-if="shopDevice.cnt1stMonth">首月</span>
                            <span v-else>次月</span>
                        </div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>累计折旧金额（元）</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.aggtDeprWorth == null ? '无' : shopDevice.aggtDeprWorth.toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>剩余折旧月数</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.leftMonths || 0}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>报废数量</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.scrappedQuantity || 0}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>清理日期</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.fiscalOutTime || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产闲置</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.assetIdleX ? '是' : '否'}}</span>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="singleTobObj.assetStatisInfoFalg">
            <div class="content-caption dashed">
                <span>资产统计信息</span>
            </div>
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>在账数量</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.fiscalQuantity || 0}}</span>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="singleTobObj.srcInfoFalg">
            <div class="content-caption dashed">
                <span>来源信息</span>
            </div>
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>批次号</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.batchNo || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>厂商序列号</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDevice.vendorSn || '无' ">{{shopDevice.vendorSn || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>统一商品代码(UPC)</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDevice.upc || '无' ">{{shopDevice.upc || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>卖家名称</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.sellerName || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>供商商户内部编码</label>
                    </div>
                    <div class="form-value">
                        <span :title="shopDevice.innerVendorNo || '无' ">{{shopDevice.innerVendorNo || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>初始合同编号</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.initContractNo || "无"}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>收货时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.receiveTime || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>导入</label>
                    </div>
                    <div class="form-value">
                        <span>{{shopDevice.imported ? '是' : '否'}}</span>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="singleTobObj.imgInfoFalg">
            <div class="content-caption dashed">
                <span>资产图片</span>
            </div>
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产图片</label>
                    </div>
                    <div class="form-value">
                        <div class="file-area clearfix" v-if="shopDevice.imageUrl != null && shopDevice.imageUrl.length > 0">
                            <div class="file-item image viewable downloadable">
                                <div class="file-content" @click="viewImage(shopDevice.imageUrl)">
                                    <img :src="shopDevice.imageUrl"/>
                                    <div class="operation-group">
                                        <i class="icon iconfont icon-chakan view"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <img v-resc-url="'/image/noimg.jpg'"/>
                        </div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>现场图片</label>
                    </div>
                    <div class="form-value">
                        <div class="file-area clearfix" v-if="shopDevice.spotImageUrl != null && shopDevice.spotImageUrl.length > 0">
                            <div class="file-item image viewable downloadable">
                                <div class="file-content" @click="viewImage(shopDevice.spotImageUrl)">
                                    <img :src="shopDevice.spotImageUrl"/>
                                    <div class="operation-group">
                                        <i class="icon iconfont icon-chakan view"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <img v-resc-url="'/image/noimg.jpg'"/>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <div class="content-caption dashed" v-if="shopDevice.classifyTagId != null && shopDevice.classifyTagId != -1">
            <span>自定义属性</span>
        </div>
        <!--<swb-prop-editor v-if="shopDevice.classifyTagId != null && shopDevice.classifyTagId != -1" ref="prop_editor" :name="'demo-prop-editor'" :widthForLabel='150' :propList="propList" :viewMode="true"></swb-prop-editor>-->
        <div class="simple-form flex col-4" v-if="shopDevice.classifyTagId != null && shopDevice.classifyTagId != -1">
            <div class="form-group center" v-for="itemInfo in propList">
                <div class="form-label">
                    <label>{{itemInfo.label}}</label>
                </div>
                <div class="form-value">
                    <template v-if="itemInfo.type != null && itemInfo.type == 'linkUrl'">
                        <!--:href="itemInfo.value" target="_blank"-->
                        <a class="swb-btn swb-btn-link" @click="viewAsVideo(itemInfo.value)">{{itemInfo.value}}</a>
                    </template>
                    <span v-else>{{itemInfo.value || ''}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes, getComnMerchantBizTag} from '../../app.vues'
    import appConf from '../../app.conf';
    import {getDefaultPageSizes} from '../../app.conf'
    import {getDevcGroupNameByCatId} from '../index'
    import {openDeprSpecDetailDlg} from '../devcDef/showDlg'
    import {openVedioPlayerDlg} from '../ctrl/dialog';
    //
    import devcApi from '../../api/devc'
    import shopDevcApi from '../../api/shopDevc'
    import merchtComnApi from '../../api/merchtComn'

    let bizTagObj = null;
    export default {
        name: 'swb-shop-device-info',
        desc: '资产详情',
        props: {
            id: {
                type: Number,
                default: null
            },
            showSingleTobObj: {
                type: Object,
                default: null
            }
        },
        data: function () {
            return {
                // 所有的分组默认展示
                singleTobObj: {
                    devcBaseInfoFalg: true,
                    repairInfoFalg: true,
                    manageInfoFalg: true,
                    useInfoFalg: true,
                    devcStatisInfoFalg: true,
                    srcInfoFalg: true,
                    assetBaseInfoFalg: true,
                    financeInfoFalg: true,
                    assetStatisInfoFalg: true,
                    imgInfoFalg: true,
                },
                shopDevice: {},
                devcVoucherTypeList: getEnumMap("devcVoucherType", "value2text"),
                assetNatureList: getEnumList("assetNature"),
                acctEnterWayMap: getEnumMap("acctEnterWay", "value2text"),
                assetDeprMethodMap: getEnumMap("assetDeprMethod", "name2text"),
                //
                propList: [],
            }
        },
        created: function () {
            bizTagObj = getComnMerchantBizTag();
            // 处理分组显示
            let showSingleTobObj = this.showSingleTobObj;
            if (!Utils.isNoB(showSingleTobObj)) {
                let singleTobObj = this.singleTobObj;
                for (let key in showSingleTobObj) {
                    singleTobObj[key] = showSingleTobObj[key];
                }
                this.singleTobObj = Utils.merge({}, singleTobObj);
            }
            this.getDevcCustFieldList();
            //
            this.getshopDevice();
        },
        methods: {
            viewAsVideo(fileBrowseUrl) {
                openVedioPlayerDlg(fileBrowseUrl);
            },
            getDevcGroupNameByCatId(catId){
                return getDevcGroupNameByCatId(catId);
            },
            getshopDevice: function () {
                let self = this;
                let postData = {
                    id: this.id,
                    containMgmt: true,
                    containAsset: true,
                    containMaint: true
                };
                let theLoad = MsgBox.loading();
                devcApi.getShopDeviceById(postData, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        let shopDevice = result.data;
                        shopDevice = Object.assign(shopDevice, shopDevice.devcMgmtAspkt);
                        shopDevice = Object.assign(shopDevice, shopDevice.devcAssetAspkt);
                        shopDevice = Object.assign(shopDevice, shopDevice.devcMaintAspkt);
                        self.makeBizTag(shopDevice);
                        //
                        self.shopDevice = shopDevice;
                        //
                        if (shopDevice.classifyTagId != null && shopDevice.classifyTagId != -1) {
                            self.classifyTagId = shopDevice.classifyTagId;
                            self.classifyTagName = shopDevice.classifyTagName;
                            self.getTagSpecField(function () {
                                self.getDevcCustInfo();
                            });
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            makeBizTag: function (shopDevice) {
                let bizTag = shopDevice.bizTag;
                let tagIdList = [];
                if (!Utils.isNoB(bizTag)) {
                    if (bizTag.indexOf("|") >= 0) {
                        bizTag = bizTag.substring(1, bizTag.length - 1);
                        tagIdList = bizTag.split("|") || [];
                    } else {
                        tagIdList.push(bizTag);
                    }
                }
                let tagNames = [];
                for (let i = 0; i < tagIdList.length; i++) {
                    let tagId = tagIdList[i];
                    let tagName = bizTagObj.getBizTagNameById(tagId);
                    if (!Utils.isNoB(tagName)) {
                        tagNames.push(tagName);
                    }
                }
                shopDevice.tagNames = tagNames;
            },
            getDevcCustFieldList(){
                let self = this;
                let theLoading = MsgBox.loading();
                merchtComnApi.getDevcCustFieldList({}, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        let devcCustFieldList = result.data;
                        self.devcCustFieldList = devcCustFieldList;
                        self.devcCustFieldMap = devcCustFieldList.toMap('id');
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getTagSpecField(callback){
                let self = this;
                let devcCustFieldMap = self.devcCustFieldMap;
                let postData = {};
                postData.classifyTagId = this.classifyTagId;
                //
                let theLoading = MsgBox.loading();
                merchtComnApi.getDevcClassifyTagSpecFields(postData, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        let tagSpecFieldList = result.data;
                        let propList = [];
                        tagSpecFieldList.forEach(function (tagField) {
                            let field = devcCustFieldMap[tagField.custFieldId];
                            propList.push({
                                label: field.title,
                                code: field.name,
                                valueType: field.type,
                                tooltip: field.desc,
                                required: tagField.required
                            });
                        });
                        self.propList = Utils.merge([], propList);
                        callback();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDevcCustInfo(){
                let self = this;
                let postData = {};
                postData.id = this.shopDevice.id;
                let theLoad = MsgBox.loading();
                shopDevcApi.getDevcCustInfo(postData, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        let devcCustInfo = result.data;
                        let custJson = JSON.decode(devcCustInfo.custJson);
                        let propList = self.propList;
                        propList.forEach(function (prop) {
                            if (!Utils.isNoB(custJson[prop.code])) {
                                if (custJson[prop.code].substr(0, 5) == 'http:' || custJson[prop.code].substr(0, 5) == 'https') {
                                    prop.type = 'linkUrl'
                                }
                                prop.value = custJson[prop.code];
                            }
                        });
                        self.propList = Utils.merge([], propList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            viewImage: function (fileBrowseUrl) {
                Utils.setPageUrl(fileBrowseUrl, '_blank');
            },
            showDeprSpec(deprSpecId){
                openDeprSpecDetailDlg(deprSpecId);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devc/ShopDeviceInfo.vue